// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-Content-module--cls1--1n2hk","cls2":"contacts-Content-module--cls2--2J362 contacts-Content-module--cls1--1n2hk"};